const http = {
    async get(url) {
        const response = await fetch(url, { credentials: "include" });

        if (response.status === 401) {
            window.location = "/unauthorized";
            return;
        }

        if (!response.ok) {
            const err = await response
                .json()
                .catch(() => ({ Message: response.statusText }));
            console.log(err);
            return Promise.reject(err);
        }

        const data = await response.json();
        return { data };
    },
};

export default http;
